if (
  typeof console !== undefined
  && !console.label
) {
  console.label = (label, data) => {
    if (
      Array.isArray(label)
      || label instanceof Object
    ) {
      for (const key in label) {
        console.log(`-- START ${key} --`);
        (
          (
            Array.isArray(label[key])
            || label[key] instanceof Object
          )
          && typeof console.json === 'function'
        ) ? console.json(label[key]) : console.log(label[key]);
        console.log(`-- END ${key} --\n`);
      }
    } else {
      console.log(`-- START ${label} --`);
      (
        (
          Array.isArray(data)
          || data instanceof Object
        )
        && typeof console.json === 'function'
      ) ? console.json(data) : console.log(data);
      console.log(`-- END ${label} --\n`);
    }
    return true;
  }
}